import styled from 'styled-components';
import { colours } from 'themes/default';

const StyledCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  background-color: ${colours.Greyscale.MistGrey};
  margin: 30px 0;

  .page-selector {
    margin: 10px 10px 0 10px;
  }
`;

export { StyledCheckboxWrapper };
